import { render, staticRenderFns } from "./QueryShow.vue?vue&type=template&id=3aa96bd4"
import script from "./QueryShow.vue?vue&type=script&lang=js"
export * from "./QueryShow.vue?vue&type=script&lang=js"
import style0 from "./QueryShow.vue?vue&type=style&index=0&id=3aa96bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports